










































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Spinner from '@/components/Spinner.vue';
import ConnectionErrorContent from '@/components/ConnectionErrorContent.vue';

export interface Category {
    id: string;
    title: string;
    image: string;
}

@Component({
  components: {
    Spinner,
    ConnectionErrorContent,
  },
})
export default class EditCategories extends Vue {
    private statusAll!: string;
    private categoriesList!: Category[];
    private categoriesList2!: Category[];
    private newCategory!: Category;
    private selectedImages!: any[][];
    private imgUploadProgress!: number[];

    private data() {
        return {
            statusAll: 'loading',
            categoriesList: [],
            categoriesList2: [],
            newCategory: {id: '', title: '', image: ''},
            selectedImages: [],
            imgUploadProgress: [],
        };
    }

    private created() {
        this.$store.state.mobileSidebarVisible = false;
        this.$store.state.menuVisible = false;
        this.loadData();
    }

    private loadData() {
        this.statusAll = 'loading';
        this.categoriesList = [];
        this.$http.get('categories/get/all').then((response: AxiosResponse) => {
            this.categoriesList = response.data;
            this.categoriesList2 = this.categoriesList.sort((a, b) => a.title.localeCompare(b.title));
            this.categoriesList = this.categoriesList2;
            for (let i = 0; i < response.data.length; i++) {
                this.selectedImages.push([]);
                this.imgUploadProgress.push(0);
            }
            this.statusAll = 'success';
        }).catch((error) => {
            this.statusAll = 'error';
        });
    }

    private createNewCategory() {
        if (this.newCategory.title !== '') {
            this.$http.post('categories/new/' + this.newCategory.title, 'ImageData').then((response: AxiosResponse) => {
                // this.statusList = 'success';
                this.newCategory = {id: '', title: '', image: ''};
                this.loadData();
            }).catch((error) => {
                // this.statusList = 'error';
            });
        }
    }

    private updateCategory(category: Category, index: number) {
        if (this.selectedImages[0] !== undefined) {
            // sende Bild + Kategorie
            const formData = new FormData();
            formData.append('image', this.selectedImages[index][0]);
            this.$http.post('categories/images/new/' + category.id, formData, {
                onUploadProgress: (uploadEvent) => {
                    this.imgUploadProgress[index] = Math.round((uploadEvent.loaded / uploadEvent.total * 100));
                },
            })
            .then((response: AxiosResponse) => {
                if (response.data.msg === 'Success') {
                    category.image = category.id;
                    this.sendCategory(category);
                }
            });
        } else {
            // sende Kategorie
            this.sendCategory(category);
        }
    }

    private sendCategory(category: Category) {
        this.$http.post('categories/update', category).then((response: AxiosResponse) => {
            // this.statusList = 'success';
            this.loadData();
        }).catch((error) => {
            // this.statusList = 'error';
        });
    }

    private deleteCategory(id: string) {
        this.$http.post('categories/delete/' + id).then((response: AxiosResponse) => {
            
            this.loadData();
        }).catch((error) => {
            // this.statusList = 'error';
        });
    }

    private onImageSelected(i: number, event: any) {
        this.selectedImages[i] = event.target.files;
    }

    private removeSelectedImage(i: number) {
        this.selectedImages[i] = [];
    }
}
